export default __webpack_public_path__ + "static/intro-tile-8-product-campaigns-9942c5ae5b5cbb12d9b038ecb0ee32cf.jpg";